import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./Page.module.css";

export interface PageProps extends React.ComponentPropsWithoutRef<"div"> {
  as?: "div" | "main" | "section" | "article";
  /** `content` = `--content-max` (1180px); `narrow` = una columna de lectura o de formulario (560px); `none` = todo el ancho. */
  width?: "content" | "narrow" | "none";
  /** Espacio entre los bloques hijos. */
  gap?: "sm" | "md" | "lg";
  /** Sin padding, para pantallas que arman su propio borde (mapas, medios). */
  flush?: boolean;
}

/** El cuerpo de una pantalla debajo del `TopBar`: padding de página, columna de bloques con espacio entre ellos. */
export function Page({ as = "div", width = "content", gap = "md", flush, className, ...rest }: PageProps) {
  const Tag = as as React.ElementType;
  return <Tag className={cx(s.page, className)} data-width={width} data-gap={gap} data-flush={flush || undefined} {...rest} />;
}
